<template>
    <div>
        <h3 class="title" :class="{ current: item.isCurrentStatus }">{{ title }}</h3>
        <p class="message" v-if="item.comment">«{{ item.comment }}»</p>
        <span class="date">{{ date }}</span>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        title: '',
        date: '',
    }),
    computed: {
        formattedDate() {
            if (!this.item) return '';
            let date = new Date(this.item.createdAt);
            let day = date.getDate().toString().padStart(2, '0');
            let month = (date.getMonth() + 1).toString().padStart(2, '0');
            let hours = date.getHours().toString().padStart(2, '0');
            let minutes = date.getMinutes().toString().padStart(2, '0');
            return `${day}.${month}.${date.getFullYear()} в ${hours}:${minutes}`;
        },
    },
    methods: {
        updateContents() {
            let title = '';
            let date = this.formattedDate;
            switch (this.item.action) {
                case 1:
                    title = 'Новая';
                    date = 'Создана ' + date;
                    break;
                case 2:
                    title = 'На рассмотрении';
                    date = 'Переведена ' + date;
                    break;
                case 3:
                    title = 'Доработка';
                    date = 'Переведена ' + date;
                    break;
                case 4:
                    title = 'На рассмотрении';
                    date = 'Переведена ' + date;
                    break;
                case 5:
                    title = 'Резерв';
                    date = 'Переведена ' + date;
                    break;
                case 6:
                    title = 'Инициатива отклонена';
                    date = 'Переведена ' + date;
                    break;
                case 7:
                    title = 'Инициатива согласована';
                    date = 'Переведена ' + date;
                    break;
                case 8:
                    title = 'Заявка удалена автором';
                    date = 'Переведена ' + date;
                    break;
                case 9:
                    title = this.item.initiatorRole === 1 ? 'Ваш комментарий:' : 'Комментарий администратора:';
                    break;
                case 10:
                    title = 'Комментирование включено';
                    break;
                case 11:
                    title = 'Комментирование отключено';
                    break;
                case 12:
                    title = 'Изменён администратор заявки';
                    break;
                case 13:
                    title = 'Заявка удалена администратором';
                    break;
                case 14:
                    title = 'Удаленная заявка восстановлена администратором';
                    break;
                case 15:
                    title = 'Удаленная заявка восстановлена автором';
                    break;
                default:
                    return;
            }
            if (this.item.isCurrentStatus) {
                title = 'Текущий статус: ' + title.toLocaleLowerCase();
            }
            this.title = title;
            this.date = date;
        },
    },
    watch: {
        item(v) {
            if (!v) return;
            this.updateContents();
        },
    },
    mounted() {
        this.updateContents();
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';

    .title {
        font-weight: 600;
        font-size: rem(18);
        line-height: rem(26);
        color: #2A2626;
        margin-top: rem(24);
        margin-bottom: rem(8);

        @include on-mobile {
            font-size: mrem(18);
            line-height: mrem(26);
            margin-top: 0;
            margin-bottom: mrem(8);
        }

        &.current {
            color: #D1004A;
        }
    }
    .message {
        font-size: rem(16);
        line-height: rem(24);
        color: #2A2626;
        margin-top: rem(8);
        margin-bottom: rem(8);

        @include on-mobile {
            font-size: mrem(16);
            line-height: mrem(24);
            margin-top: mrem(8);
            margin-bottom: mrem(8);
        }
    }
    .date {
        font-size: rem(16);
        line-height: rem(24);
        color: #2A2626;

        @include on-mobile {
            display: block;
            font-size: mrem(16);
            line-height: mrem(24);
            margin-bottom: mrem(24);
        }
    }
</style>
